import Tea from 'byted-tea-sdk';

const isOnline = process.env.ENV === 'online';
const isKA = process.env.IS_KA && process.env.IS_KA === 'true';
let defaultParams = {};

export const initTea = (token: string) => {
    if (isKA) return;
    // 1. 初始化SDK，必须。
    Tea.init({
        app_id: 1943, // number类型的appId
        channel: 'cn',
        log: !isOnline // 开启调试日志
    });

    // 2. 按需配置
    Tea.config({
        _staging_flag: isOnline ? 0 : 1, // 是否发到测试库
        user_unique_id: token,
        evtParams: {
            project_name: 'otps' // 当前项目名称，方便后续在TEA上进行过滤
        }
    });

    Tea.send();
};

export const checkInInitTea = (params: any) => {
    if (isKA) return;
    // 1. 初始化SDK，必须。
    Tea.init({
        app_id: 1943, // number类型的appId
        channel: 'cn',
        log: !isOnline // 开启调试日志
    });

    // 2. 按需配置
    Tea.config({
        _staging_flag: isOnline ? 0 : 1, // 是否发到测试库
        user_unique_id: 'interviewer_checkIn',
        evtParams: {}
    });

    defaultParams = {
        uid: 'external user',
        ...params
    };

    Tea.send();
};

export const questionnaireInitToken = (params: any) => {
    if (isKA) return;
    // 1. 初始化SDK，必须。
    Tea.init({
        app_id: 1943, // number类型的appId
        channel: 'cn',
        log: !isOnline // 开启调试日志
    });

    // 2. 按需配置
    Tea.config({
        _staging_flag: isOnline ? 0 : 1, // 是否发到测试库
        user_unique_id: 'interview-questionnaire',
        evtParams: {}
    });

    defaultParams = {
        uid: 'external user',
        ...params
    };

    Tea.send();
};

export const jobFairInitToken = (params: any) => {
    if (isKA) return;
    // 1. 初始化SDK，必须。
    Tea.init({
        app_id: 1943, // number类型的appId
        channel: 'cn',
        log: !isOnline // 开启调试日志
    });

    // 2. 按需配置
    Tea.config({
        _staging_flag: isOnline ? 0 : 1, // 是否发到测试库
        user_unique_id: 'job-fair-candidate',
        evtParams: {}
    });

    defaultParams = {
        uid: 'job-fair-candidate',
        ...params
    };

    Tea.send();
};

export const teaTrack = (event: string, params: { [index: string]: any } = {}) => {
    if (isKA) return;
    Tea(event, { ...defaultParams, ...params });
};
